// extracted by mini-css-extract-plugin
export default {"btn-nav":"Navbar_btn-nav__uymxi"};